import { Brand, createBranded } from '@deltasierra/type-utilities';

export type FileName = Brand<string, 'FileName'>;
export const FileName = createBranded<FileName>();
